import FraudErrorCodes from "@irati/fraud/errorCodes/Fraud"

import type {ErrorHandlerCallback} from "@irati/utils/services/API/utils/errorHandler/register"
import {filterMap} from "@irati/utils/object"
import RewardErrorCodes from "../../errorCodes/Reward"

const rewardErrorHandler: ErrorHandlerCallback = (code, error) => {
  if (["PBRewardPointsApp", "PBRecognitionApp"].map((svc) => svc + "InvalidRewardAmount").includes(code)) {
    return [
      "errors.MinMaxInvalidRewardAmount",
      filterMap(error?.errorData ?? {}, (key, value) => (["min", "max"].includes(key) ? [key, "" + parseInt(value) / 100] : [key, value]))
    ]
  }
  switch (code) {
    case RewardErrorCodes.OrderInput:
      return "errors.PBERROrderInput"
    case RewardErrorCodes.OrderNotFound:
      return "errors.PBERROrderNotFound"
    case RewardErrorCodes.OrderCreate:
      return "errors.PBERROrderCreate"
    case RewardErrorCodes.OrderInvalidInput:
      return "errors.PBERROrderInvalidInput"
    case RewardErrorCodes.OrderSnapshot:
      return "errors.PBERROrderSnapshot"
    case RewardErrorCodes.InsufficientStock:
      return "errors.PBERRInsufficientStock"
    case RewardErrorCodes.InvalidJSON:
      return "errors.PBERRInvalidJSON"
    case RewardErrorCodes.InvalidArgument:
      return "errors.PBERRInvalidArgument"
    case RewardErrorCodes.RewardInput:
      return "errors.PBERRRewardInput"
    case RewardErrorCodes.RewardNotFound:
      return "errors.PBERRRewardNotFound"
    case RewardErrorCodes.RewardFilters:
      return "errors.PBERRRewardFilters"
    case RewardErrorCodes.RewardURLSlugExists:
      return "errors.PBERRRewardURLSlugExists"
    case RewardErrorCodes.RewardInternalIdentifierExists:
      return "errors.PBERRRewardInternalIdentifierExists"
    case RewardErrorCodes.NotAllowed:
      return "errors.PBERRNotAllowed"
    case RewardErrorCodes.RewardPayment:
      return "errors.PBREWPayment"
    case FraudErrorCodes.PBPAYFraudThresholdHit:
      return "errors.RewardPBPAYFraudThresholdHit"
    default:
      return ""
  }
}
export default rewardErrorHandler
